import React, { Component } from "react";
import BuildingRow from "../BuildingRow";
import { isNullOrEmpty } from "../Util";

export class BuildingList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			Buildings: [],
		};

		this.buildingSelected = this.buildingSelected.bind(this);
	}
	componentDidMount() {
		this.getData();
	}

	componentDidUpdate(prevProps) {
		if (this.props.Inactive !== prevProps.Inactive) this.getData();
	}

	async getData() {
		var result = null;
		if (!this.props.IsClientPortal) {
			result = await (!this.props.Inactive ? fetch("Building") : fetch("Building/GetBuildingsInactive"));
		} else {
			result = await fetch("Building/GetClientPortalBuildings", {
				method: "Post",
				cache: "no-cache",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ usersId: this.props.UsersID }),
			});
		}
		var data = await result.json();

		data.sort((a, b) => {
			return a.building_name.localeCompare(b.building_name);
		});
		this.setState({
			Buildings: data,
		});

		if (this.state.Buildings.length > 0 && this.props.onSelectRow && isNullOrEmpty(this.props.building)) {
			this.props.onSelectRow(this.state.Buildings[0]);
			this.buildingSelected(this.state.Buildings[0].buildings_id);
		} else if (!isNullOrEmpty(this.props.building)) {
			this.buildingSelected(this.props.building);
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.Filter !== this.props.Filter) {
			this.render();
		} else if (prevProps.updatedDate !== this.props.updatedDate) {
			this.getData();
		}
	}

	buildingSelected(bldgId) {
		this.setState({ selected: bldgId });
	}

	render() {
		var bldgs = this.state.Buildings;

		if (this.props.Filter) {
			bldgs = bldgs.filter((item) => {
				return item.building_name.toLowerCase().indexOf(this.props.Filter.toLowerCase()) > -1;
			});
		}

		return (
			<div className="d-flex flex-fill flex-column" style={{ backgroundColor: "#ebebeb", padding: "4px", overflowY: "auto" }}>
				{bldgs.map((bldg) => {
					return (
						<BuildingRow
							Selected={bldg.buildings_id === this.state.selected}
							IsClientPortal={this.props.IsClientPortal}
							key={bldg.buildings_id}
							buildingData={bldg}
							Condensed={this.props.Condensed}
							onClick={(row) => {
								this.props.onSelectRow(row);
								this.buildingSelected(row.buildings_id);
							}}
						/>
					);
				})}
			</div>
		);
	}
}
